import { ROUTES } from 'consts';

export const useExeptions = (pathname: string) => {
  // Реализуем данный подход в связи с текущими ограничениями в реализации компонента Header tend-ui

  // Хук заменяет урлы подстраниц попавших в список на коренной урл.
  // Предполагается использование только в рамках useSelected или useSelectedV2
  //
  // example:
  // Before: /plan/allChangeVersions
  // After: /plan
  const plan_exeptions = [
    ROUTES.PLAN.ALL_CHANGE_VERSIONS,
    ROUTES.PLAN.CHANGE_VERSION_DETAIL,
    ROUTES.PLAN.READONLY,
    ROUTES.PLAN.NEW,
    ROUTES.PLAN.NEW_PLACEMENTS,
    ROUTES.PLAN.NEW_ENGINEERING,
    ROUTES.PLAN.OVP,
    ROUTES.PLAN.EDIT,
  ];

  const delivery_schedule_exeptions = [ROUTES.DELIVERY_SCHEDULE.APARTMENTS_DETAIL];

  let result: string;
  const isPlanRoot = pathname.includes('/plan/');
  const isDeliveryScheduleRoot = pathname.includes('/deliverySchedule/');

  if (isPlanRoot) {
    result = plan_exeptions.includes(pathname) ? ROUTES.PLAN.ROOT : pathname;
  } else if (isDeliveryScheduleRoot) {
    result = delivery_schedule_exeptions.includes(pathname)
      ? ROUTES.DELIVERY_SCHEDULE.ROOT
      : pathname;
  } else {
    result = pathname;
  }

  return result;
};
